import moment from "moment";

export function formatDisplayDate(string, raw = false) {
  let formattedDate = "";
  let date;

  if (string && string.length > 0) {
    date = moment(string, "YYYY-MM-DD");
    formattedDate = date.format("MMMM Do, YYYY");
  }

  if (formattedDate !== "Invalid date") {
    if (raw) {
      return date;
    } else {
      return formattedDate;
    }
  }

  return "";
}
